module.exports = __webpack_public_path__ + "img/notebook-livro.9fc62869.png";